/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 6/24/14
 * Time: 5:22 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var _ = require("underscore");
    var Logger = require("logger");

    var extend = function (protoProps, staticProps) {
        var parent = this;
        var child;

        // The constructor function for the new subclass is either defined by you
        // (the "constructor" property in your `extend` definition), or defaulted
        // by us to simply call the parent's constructor.
        if (protoProps && _.has(protoProps, "constructor")) {
            child = protoProps.constructor;
        } else {
            child = function () {
                return parent.apply(this, arguments);
            };
        }

        // Add static properties to the constructor function, if supplied.
        _.extend(child, parent, staticProps);

        // Set the prototype chain to inherit from `parent`, without calling
        // `parent`'s constructor function.
        var Surrogate = function () {
            this.constructor = child;
        };

        Surrogate.prototype = parent.prototype;
        child.prototype = new Surrogate();

        // Add prototype properties (instance properties) to the subclass,
        // if supplied.
        if (protoProps) {
            _.extend(child.prototype, protoProps);
        }

        // Set a convenience property in case the parent's prototype is needed
        // later.
        child.__super__ = parent.prototype;

        return child;
    };

    var AbstractAppender = function (attributes) {
        this.attrs = attributes || {};
        this.initialize.apply(this, [].slice.apply(arguments));
    };

    // Attach all inheritable methods to the AbstractAppender prototype.
    _.extend(AbstractAppender.prototype, {

        initialize: function (options) {
            this.App = options.application;
            this.logger = Logger.getLogger("NotificationAppender");
        },
        isEnabled: function () {
            return true;
        },
        isSupported: function () {
            return true;
        },
        getDefaultOptions: function () {
            throw new Error("NotificationCenter - AbstractAppender::getDefaultOptions You must implement abstractMethod");
        },
        notify: function (options) {
            throw new Error("NotificationCenter - AbstractAppender::notify You must implement abstractMethod");
        },
        isValidOptions:function(options){
           return (typeof options === "object");

        },
        clearNotification:function(options){
            throw new Error("NotificationCenter - AbstractAppender::clearNotification You must implement abstractMethod");
        },
        isValidClearNotificationOptions:function(options){
            return (typeof options === "object");

        }

    });

    AbstractAppender.extend = extend;

    return AbstractAppender;
});

